import { SET_HEADER } from "redux/actions/header";

const initState = {};

export const headerReducer = (header = initState, action) => {
  switch (true) {
    case action.type.includes(SET_HEADER):
      return { ...header, ...action.payload };
    default:
      return header;
  }
};
